<template>
    <div id="EditProfileDiv">
      <HeaderVue isHeader="true"/>
      <div class="inner-page phleb-signup my-profile">
          <div class="container">
              <div class="row">
                  <div class="col-lg-8 offset-lg-2 col-sm-8 offset-sm-2">
                      <div class="sign-up">
                          <div class="signup-title">
                              <h4 class="mt-0 mb-0">Edit Account</h4>
                          </div>
                          <div class="form-content line-textbox">
                              <form data-vv-scope="edit">
                                  <!-- <div class="clearfix">
                                      <div class="testimonial-dp">
                                      </div>
                                      <p class="blue-color mt-5 float-left">Add Photo</p>
                                  </div> -->
                                  <div class="clearfix mt-4">
                                      <div class="row">
                                          <div class="col-sm-6">
                                              <div class="form-group">
                                                  <label>First Name</label>
                                                  <input class="form-control" type="text" name="firstName" data-vv-as="first name" v-model="firstName" maxlength="50" v-validate="'required|alpha_spaces|min:3|max:50'">
                                                  <span v-show="errors.has('edit.firstName')" class="text-danger">{{ errors.first('edit.firstName') }}</span>
                                              </div>
                                          </div>
                                          <div class="col-sm-6">
                                              <div class="form-group">
                                                  <label>Last Name</label>
                                                  <input class="form-control" name="lastName" type="text" data-vv-as="last name" v-model="lastName" maxlength="50" v-validate="'required|alpha_spaces|min:3|max:50'">
                                                  <span v-show="errors.has('edit.lastName')" class="text-danger">{{ errors.first('edit.lastName') }}</span>
                                              </div>
                                          </div>
                                      </div>
                                      <div class="row">
                                          <div class="col-sm-6">
                                              <div class="form-group">
                                                  <label>Gender</label>
                                                  <div class="form-check form-check-inline" style="margin-top:15px; margin-bottom:0px;">
                                                      <label class="form-check-label">
                                                          <input class="form-check-input" type="radio" name="gender" id="inlineRadio1" value="M" v-model="sex" :checked="(sex === 'M')?true:false"> Male
                                                      </label>
                                                  </div>
                                                  <div class="form-check form-check-inline" style="margin-top:15px; margin-bottom:0px;">
                                                      <label class="form-check-label">
                                                          <input class="form-check-input" type="radio" name="gender" id="inlineRadio2" value="F" v-model="sex" :checked="(sex === 'F')?true:false"> Female
                                                      </label>
                                                  </div>
                                                  <div class="form-check form-check-inline" style="margin-top:15px; margin-bottom:0px;">
                                                      <label class="form-check-label">
                                                          <input class="form-check-input" type="radio" name="gender" id="inlineRadio3" value="O" v-model="sex" :checked="(sex === 'O')?true:false"> Other
                                                      </label>
                                                  </div>
                                                  
                                              </div>
                                          </div>
                                          <div class="col-sm-6">
                                            <div class="form-group" >
                                                <label>Date of birth</label>
                                                <div class="row">
                                                    <div class="col-4">
                                                        <select class="form-control" name="year" id="year"  v-model="year" v-on:change="getNumberOfDays()">
                                                            <option value="" class="dobOptionColor" disabled selected>YYYY</option>
                                                            <option v-for="(dobYear, index) in dobYears" v-bind:value="dobYear" :key='index'>{{dobYear}}</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-4">
                                                        <select class="form-control" name="month" id="month" v-model="month" v-on:change="getNumberOfDays()">
                                                            <option value="" class="dobOptionColor" disabled selected>MMM</option>
                                                            <option value="01">Jan</option>
                                                            <option value="02">Feb</option>
                                                            <option value="03">Mar</option>
                                                            <option value="04">Apr</option>
                                                            <option value="05">May</option>
                                                            <option value="06">Jun</option>
                                                            <option value="07">Jul</option>
                                                            <option value="08">Aug</option>
                                                            <option value="09">Sep</option>
                                                            <option value="10">Oct</option>
                                                            <option value="11">Nov</option>
                                                            <option value="12">Dec</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-4">
                                                    <select class="form-control" name="ddate" id="ddate" v-model="ddate">
                                                        <option value="" class="dobOptionColor" disabled selected>DD</option>
                                                        <option v-for="(dobDateVal, index) in dobDate" v-bind:value="dobDateVal ? (parseInt(dobDateVal) < 10 ? '0'+dobDateVal : dobDateVal) : ''" :key='index'>{{dobDateVal ? (parseInt(dobDateVal) < 10 ? '0'+dobDateVal : dobDateVal) : '' }}</option>
                                                    </select>
                                                    </div>
                                                    <div class="col-sm-12">
                                                        <span v-if="isDobError" class="text-danger">The date of birth field is required</span>
                                                    </div>
                                                </div>
                                            </div>
                                              <!--<div class="form-group">
                                                  <label>Date of birth</label>
                                                  <div class="input-group dobBorderRemoval">
                                                      <datepicker class="form-control" name="dob" id="dob" v-model="dob" data-vv-as="date of birth" :format="'dd/MM/yyyy'" :disabled="disabled" v-validate="'required'" required></datepicker>
                                                      <span class="input-group-btn">
                                                          <button class="btn btn-link white-bg" type="button">
                                                              <img src="static/images/calender.svg" class="m-0" alt="" onClick="document.getElementById('dob').focus()">
                                                          </button>
                                                      </span>
                                                  </div>
                                                  <span v-if="isDobError" class="text-danger">The date of birth field is required</span>
                                              </div>-->
                                          </div>
                                      </div>
                                      <div class="row">
                                          <div class="col-sm-6">
                                              <div class="form-group">
                                                  <label>Mobile</label>
                                                  <input class="form-control" type="text" ref="mobile" name="phone1" data-vv-as="mobile no." v-model="phone1" v-validate="'required|numeric|min:10|max:10'">
                                                  <span v-show="errors.has('edit.phone1')" class="text-danger">{{ errors.first('edit.phone1') }}</span>
                                                  <span v-show="isMobileError" class="text-danger">{{ mobileErrorMsg }}</span>
                                              </div>
                                          </div>
                                          <div class="col-sm-6">                                              
                                              <div class="form-group">
                                                  <label>Alternate Phone No.</label>
                                                  <input class="form-control" type="text" name="phone2" data-vv-as="alternate phone no." v-model="phone2" v-validate="'numeric|min:10|max:10'">
                                                  <span v-show="errors.has('edit.phone2')" class="text-danger">{{ errors.first('edit.phone2') }}</span>
                                              </div>
                                          </div>
                                      </div>
                                      <div class="row">
                                          <div class="col-sm-6">
                                              <div class="form-group">
                                                  <label>Email</label>
                                                  <input style="background-color: #fff; cursor: not-allowed" class="form-control" type="email" name="email" data-vv-as="email address" v-model="email" v-validate="'required|email|max:100'" :disabled="true">
                                                  <i style="font-size: 18px; color: #000; text-align: right; float: right; margin-top: -25px; margin-right: 10px;" class="fa">&#xf023;</i>
                                                  <span v-show="errors.has('edit.email')" class="text-danger">{{ errors.first('edit.email') }}</span>
                                                  <span v-show="isError" class="text-danger">{{ 'Sorry something went wrong try again' }}</span> 
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="row mt-3">
                                      <div class="col-sm-6">
                                          <router-link to="/myprofile" class="btn btn-link full-width">Cancel</router-link>
                                      </div>
                                      <div class="col-sm-6">
                                          <button class="btn btn-primary full-width" :disabled="(errors.any())" @click.prevent="saveProfile()">Update</button>
                                      </div>
                                  </div>
                              </form>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <FooterVue />
    </div>
</template>

<script>
import HeaderVue from '@/components/mobile/Header'
import FooterVue from '@/components/mobile/Footer'
import _ from 'underscore'
import Datepicker from 'vuejs-datepicker'
import dateFormat from 'dateformat'

export default {
  name: 'EditProfile',
  components: {
    HeaderVue,
    FooterVue,
    Datepicker
  },
  beforeCreate () {
    if (!this.$localStorage.get('loggedIn') || this.$localStorage.get('loggedIn') === null) {
      this.$router.push({ path: '/' })
    }
  },
  data () {
    return {
      isDobError: false,
      firstName: '',
      lastName: '',
      email: '',
      phone1: '',
      phone2: '',
      dob: undefined,
      sex: '',
      photo: '',
      address: {},
      disabled: {
        from: new Date()
      },
      dobYears: [],
      dobDate: [],
      year: '',
      month: '',
      ddate: '',
      isMobileError : false,
      mobileErrorMsg : '',
      isError : false
    }
  },
  created () {
    let year = (new Date()).getFullYear()
    let endYear = year - 120
    for (let i = year; i > endYear; i--) {
      this.dobYears.push(i.toString())
    }
  },
  mounted () {
    this.getProfile()
  },
  methods: {
    getNumberOfDays: function (dateVal) {
      if (this.year && this.year !== '' && this.month && this.month !== '') {
        let noOfDays = new Date(this.year, this.month, 0).getDate()
        this.dobDate = []
        for (var j = 1; j <= noOfDays; j++) {
          this.dobDate.push(j.toString())
        }
        if (dateVal) {
          this.ddate = dateVal
        } else {
          if (this.ddate) {
            var res = true
            this.dobDate.forEach(function (dataV) {
              if (parseInt(dataV) === parseInt(this.ddate)) {
                res = false
              }
            }.bind(this))
            if (res) {
              this.ddate = ''
            }
          }
        }
      }
      return false
    },
    saveProfile: function () {
      this.isDobError = false
      this.isMobileError = false
      this.isError = false
      this.$validator.validateAll('edit').then((result) => {
        if (result) {
          if (this.year.length !== 4 || this.month.length <= 0 || this.ddate.length <= 0) {
            this.isDobError = true
            return false
          }
          try {
            var data = {
              'firstName': this.firstName,
              'lastName': this.lastName,
              'phone1': this.phone1,
              'phone2': this.phone2,
              'photo': '',
              'sex': this.sex,
              'dob': this.year + '-' + this.month + '-' + this.ddate,
              'panNo': '',
              'aadharNo': '',
              'drivingLicenceNo': ''
            }
            console.log(data)
            Promise.resolve(this.$POST('patient/updateProfile', data)).then(function (res) {
              if (res.response_code === 0) {
                this.$localStorage.remove('profile')
                var userDetails = {
                  'username': this.firstName + ' ' + this.lastName,
                  'firstName': this.firstName,
                  'lastName': this.lastName,
                  'phone1': this.phone1,
                  'dob': dateFormat(this.dob, 'yyyy-mm-dd', true),
                  'photo': ''
                }
                this.$localStorage.set('profile', userDetails, 0)
                this.$router.push({ path: '/myprofile' })
              } else if(res.response_code === 4){
                this.isMobileError = true
                this.mobileErrorMsg = res.response_message
                this.$refs.mobile.focus()
              } else if(res.response_code === 2){
                this.isError = true
              }
            }.bind(this)).catch(function (err) {
              console.error(err)
            })
          } catch (e) {
            console.error('method:saveProfile', e)
          }
        }
      })
    },
    getProfile: function () {
      try {
        if (this.$localStorage.get('loggedIn') && this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
          var data = {}
          Promise.resolve(this.$GET('patient/getProfile', data)).then(function (res) {
            if (res.response_code === 0) {
              if (res.response) {
                _.each(res.response.Addresses, function (item) {
                  if (item.isDefault === 1) {
                    this.address = item.address
                  }
                })
              }
              this.firstName = res.response.Patient.firstName
              this.lastName = res.response.Patient.lastName
              this.email = res.response.email
              this.phone1 = res.response.Patient.phone1
              this.phone2 = res.response.Patient.phone2
              this.dob = res.response.Patient.dob ? res.response.Patient.dob : undefined
              this.sex = res.response.Patient.sex
              if (res.response.Patient.dob && res.response.Patient.dob !== null) {
                let dob = (res.response.Patient.dob).split('T')
                let dobDate = dob[0].split('-')
                this.year = dobDate[0]
                this.month = dobDate[1]
                this.getNumberOfDays(dobDate[2])
              }
            }
            this.$hidePageLoading()
          }.bind(this)).catch(function (err) {
            console.error(err)
          })
        }
      } catch (e) {
        console.error('method:getProfile', e)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/Secure/EditProfile.vue